@if (!newBillingDesign) {
  <div>
    <p class="pad-top-20" data-cy="paymentMethodText">Add a new payment method</p>
    <div class="row">
      <a
        (click)="addCheckingAccount()"
        [ngClass]="{ disabled: !authorizedToAddPaymentMethod }"
        data-cy="checkingAccountLink"
        >Checking Account</a
      >
    </div>
    @if (displayAutoPayDiscountMessage) {
      <p class="caption margin-bottom-10">AutoPay Discount</p>
    }
    <div class="row">
      <a
        (click)="addSavingsAccount()"
        [ngClass]="{ disabled: !authorizedToAddPaymentMethod }"
        data-cy="savingsAccountLink"
        >Savings Account</a
      >
    </div>
    @if (displayAutoPayDiscountMessage) {
      <p class="caption margin-bottom-10">AutoPay Discount</p>
    }
    <div class="row">
      <a
        (click)="addCreditDebit()"
        [ngClass]="{ disabled: !authorizedToAddPaymentMethod }"
        data-cy="debitCreditCardLink"
        >Debit/Credit Card</a
      >
    </div>
  </div>
}

@if (newBillingDesign) {
  <div class="add-payment-method-modal">
    @if (!hideHeading) {
      <div
        class="modal-heading font-weight-semibold"
        dsContent
        [contentPath]="'billing.addPayMethod'"
      ></div>
    }
    <div
      class="row method-container"
      (click)="addCheckingAccount()"
      [ngClass]="{ disabled: !authorizedToAddPaymentMethod }"
      data-cy="checkingAccountLink"
    >
      <img class="account-type-icon margin-right-16" src="assets/images/bank.svg" />
      <span class="account-type" dsContent [contentPath]="'billing.addCheckingAccount'"></span>
      <span class="right-icon-container">
        <img class="right-icon align-right" src="assets/images/chevron-right-thick.svg" />
      </span>
    </div>

    @if (!isHSPolicy) {
      <div
        class="row method-container"
        (click)="addSavingsAccount()"
        [ngClass]="{ disabled: !authorizedToAddPaymentMethod }"
        data-cy="savingsAccountLink"
      >
        <img class="account-type-icon margin-right-16" src="assets/images/piggy_bank.svg" />
        <span class="account-type" dsContent [contentPath]="'billing.addSavingsAccount'"></span>
        <span class="right-icon-container">
          <img class="right-icon align-right" src="assets/images/chevron-right-thick.svg" />
        </span>
      </div>
    }

    <div
      class="row method-container"
      (click)="addCreditDebit()"
      [ngClass]="{ disabled: !authorizedToAddPaymentMethod }"
      data-cy="debitCreditCardLink"
    >
      <img class="account-type-icon margin-right-16" src="assets/images/online-payment.svg" />
      <span class="account-type" dsContent [contentPath]="'billing.addCreditOrDebitCard'"></span>
      <span class="right-icon-container">
        <img class="right-icon align-right" src="assets/images/chevron-right-thick.svg" />
      </span>
    </div>
  </div>
}
